<script lang="ts">
    import type {Audio} from "./Types";
    import type {ChatMessageAttachmentData} from "../../Types";
    import {authBlobUrl} from "../../Auth";
    import InView from "../InView.svelte";
    export let attachments: ChatMessageAttachmentData[]
    export let entity: Audio
</script>

{entity.title}<br/>
{#if attachments && attachments.length}
    {#each attachments as attachment}
        {#if attachment.telegram_remote_attachment_id == entity.audio.remote.id}
            {#if attachment.status === 'pending'}
                Запис ще не викачаний
            {:else if attachment.status === 'failed'}
                Запис викачати не вдалось
            {:else if attachment.status === 'success'}
                <InView>
                {#await authBlobUrl('/attachments/'+attachment.id)}
                    <div class="spinner-grow"></div>
                {:then src}
                    {#if src}
                        <audio controls style:width="100%">
                            <source {src} type="{entity.mime_type}">
                        </audio>
                    {:else}
                        Не вдалось завантажити.
                    {/if}
                {:catch error}
                    Не вдалось завантажити.
                {/await}
                </InView>
            {/if}
        {/if}
    {/each}
{:else}
    Не викачано
{/if}
